// TODO: TBD use MUI validation or custom
import React, { useContext, useState } from 'react';
import { Auth } from 'aws-amplify';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Box,
  Grid,
  Link,
  useTheme,
  Container,
} from '@mui/material';
import styles from './forgotPassword.module.scss';
import { ResetPassword } from './resetPassword';
import { UserNotificationContext } from '../../components/userNotification/userNotificationContext';
import { UserNotificationType } from '../../components/userNotification/userNotificationType.enum';
import { TextInput } from '../../components/textInput/textInput';
import { OnboardingDesktop } from '../login/components/smart/onBoardingDesktop.smart';
import { ConneqtLogo } from '../../components/logo/logo';
import { Button } from '../../components/button/button';

export function ForgotPassword() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { addUserNotification } = useContext(UserNotificationContext);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [inputs, setInputs] = useState({
    email: '',
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setInputs((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const setVerificationCode = async () => {
    await Auth.forgotPassword(inputs.email)
      .then(() => {
        setVerifyEmail(true);
      })
      .catch((_error) => {
        addUserNotification(
          UserNotificationType.ERROR,
          _error.message,
          UserNotificationType.ERROR,
        );
      });
  };

  return (
    <Container>
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{
          height: '100vh',
          background: theme.palette.background.default,
        }}
      >
        <Grid item xl={4} md={4} sm={12} xs={12}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            sx={{ my: 4 }}
          >
            <ConneqtLogo />
          </Grid>
          {!verifyEmail ? (
            <Box>
              <Typography
                component="h5"
                variant="h5"
                sx={{ textAlign: 'center', color: theme.palette.text.primary }}
              >
                {t('RESET_PASSWORD')}
              </Typography>
              <Typography
                component="h1"
                variant="subtitle1"
                sx={{ textAlign: 'center', color: theme.palette.text.primary }}
              >
                <p>{t('RESET_PASSWORD_DETAILS')}</p>
              </Typography>
              <TextInput
                type="email"
                label={t('EMAIL')}
                name="email"
                autoComplete="email"
                autoFocus
                fullWidth
                required
                onChange={handleInputChange}
                value={inputs.email}
              />
              <Grid textAlign="center" sx={{ mt: 2, mb: 1 }}>
                <Button
                  color="secondary"
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={setVerificationCode}
                  label={t('common.generic.GENERIC_NAVIGATION_NEXT')}
                />
                <Link href="/">{t('SIGN_IN')}</Link>
              </Grid>
            </Box>
          ) : (
            <ResetPassword email={inputs.email} />
          )}
        </Grid>
        <Grid item xl={6} md={6} sm={12} xs={12}>
          <div className={styles.onBoarding}>
            <OnboardingDesktop />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}
